import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageSeo from "../components/PageSeo";
import { fetchNearbyShowrooms, fetchShowroomBySlug, formatDistanceKm, isShowroomOpen, toggleFavorite } from "../lib/showrooms";
import { useApp } from "../context/AppContext";
import "./Showrooms.css";

export default function ShowroomDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user } = useApp();
  const [showroom, setShowroom] = useState(null);
  const [nearby, setNearby] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      const { data } = await fetchShowroomBySlug(slug);
      if (!alive) return;
      setShowroom(data || null);
      setLoading(false);
      if (data?.latitude && data?.longitude) {
        const nearbyResult = await fetchNearbyShowrooms({ latitude: data.latitude, longitude: data.longitude, limit: 6 });
        if (alive) setNearby(nearbyResult.data || []);
      }
    })();
    return () => { alive = false; };
  }, [slug]);

  const schema = useMemo(() => showroom ? {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: showroom.showroom_name,
    description: showroom.description,
    url: typeof window !== "undefined" ? window.location.href : undefined,
    telephone: showroom.phone,
    address: {
      "@type": "PostalAddress",
      addressLocality: showroom.city,
      addressRegion: showroom.state,
      streetAddress: showroom.full_address,
    },
  } : null, [showroom]);

  if (loading) return <div className="showrooms-state">Loading showroom...</div>;
  if (!showroom) return <div className="showrooms-state">Showroom not found.</div>;

  return (
    <div className="showroom-detail">
      <PageSeo title={`${showroom.showroom_name} | Bike Showroom in ${showroom.city}`} description={showroom.description || `${showroom.showroom_name} in ${showroom.city}, ${showroom.state}`} path={`/showroom/${showroom.slug}`} schema={schema} />
      <div className="showroom-cover" style={{ backgroundImage: showroom.cover_image ? `url(${showroom.cover_image})` : undefined }} />
      <div className="showroom-detail-card">
        <h1>{showroom.showroom_name}</h1>
        <p>{showroom.brand} · {showroom.area} · {showroom.city}, {showroom.state}</p>
        <p>{showroom.description}</p>
        <div className="showroom-actions">
          {showroom.whatsapp ? <a href={`https://wa.me/${String(showroom.whatsapp).replace(/\D/g, "")}`} target="_blank" rel="noreferrer">WhatsApp</a> : null}
          {showroom.phone ? <a href={`tel:${showroom.phone}`}>Call</a> : null}
          {showroom.google_map_url ? <a href={showroom.google_map_url} target="_blank" rel="noreferrer">Google Maps</a> : null}
          <button onClick={async () => { if (!user?.id) return navigate("/login"); await toggleFavorite(showroom.id, user.id, false); }}>Save</button>
        </div>
        <div>Hours: {showroom.opening_time} - {showroom.closing_time} {showroom.sunday_open ? "(Sunday open)" : ""}</div>
        <div>Open now: {isShowroomOpen(showroom) ? "Yes" : "No"}</div>
        <div>Gallery: {(showroom.gallery || []).length} photos</div>
        <div>Services: {(showroom.services || []).join(", ")}</div>
        <div>Nearby showrooms: {nearby.length}</div>
        <div className="showroom-nearby-grid">
          {nearby.map((item) => <article key={item.id} onClick={() => navigate(`/showroom/${item.slug}`)}>{item.showroom_name}</article>)}
        </div>
      </div>
    </div>
  );
}

